export enum MaritalStatusType {
  Married = 0,
  Single = 1,
  Divorced = 2,
  Widowed = 3,
  Other = 10,
}

export const MaritalLabel = new Map<number, string>([
  [MaritalStatusType.Married, 'Casado'],
  [MaritalStatusType.Single, 'Solteiro'],
  [MaritalStatusType.Divorced, 'Divorciado'],
  [MaritalStatusType.Widowed, 'Viúvo'],
  [MaritalStatusType.Other, 'Outro']
]);